import { render, staticRenderFns } from "./kw_icon.vue?vue&type=template&id=35087cfe&scoped=true&"
import script from "./kw_icon.vue?vue&type=script&lang=js&"
export * from "./kw_icon.vue?vue&type=script&lang=js&"
import style0 from "./kw_icon.vue?vue&type=style&index=0&id=35087cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35087cfe",
  null
  
)

component.options.__file = "kw_icon.vue"
export default component.exports